import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { Auth } from '../../../auth/auth.service';

export interface WidgetMapUploadResponse {
  previewUrl: string;
  fileId: string,
  size: number;
  dimensions: {
    width: number
    height: number
  }
}

@Component({
  selector: 'cw-widget-map-upload',
  templateUrl: './widget-map-upload.component.html',
  styleUrls: ['./widget-map-upload.component.scss']
})
export class WidgetMapUploadComponent implements OnInit, OnChanges {
  @Output() uploadComplete = new EventEmitter<WidgetMapUploadResponse>();
  @Output() uploadError = new EventEmitter<string>();
  @Input() url: string;

  uploader: FileUploader = new FileUploader({});
  hasBaseDropZoneOver: boolean;
  errorResponse: string;

  constructor(private auth: Auth) {

    this.uploader.onBeforeUploadItem = (item) => {
      this.errorResponse = null;
      item.withCredentials = false;
      this.uploader.authToken = 'Bearer ' + this.auth.getToken();
    };

    this.uploader.onAfterAddingFile = f => {
      this.uploader.uploadAll();
    };

    this.uploader.onCompleteItem = (item, response, status) => {
      if (status !== 200) {
        this.uploadError.emit(response);
        this.errorResponse = 'Fel vid uppladdning';
        return;
      }

      let json = JSON.parse(response);

      this.uploadComplete.emit({
        previewUrl: json.preview_url,
        size: json.size,
        dimensions: {
          width: json.dimensions.width,
          height: json.dimensions.height,
        },
        fileId: json.filename
      });

      //this.uploader.clearQueue();
    };

  }

  ngOnInit() {
  }

  ngOnChanges() {
    this.uploader.setOptions({
      url: this.url
    })
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  get uploadInProgress() {
    return this.uploader.isUploading;
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/widget-detail/widget-map-upload/widget-map-upload.component.ts